module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"tsunami\"-in-long-beach-california-0b5ba9d80768e7dcde928d28dc4b150e.png";